<style lang="less" scoped>
  .header {
    padding-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .back-btn {
    width: 44px;
    height: 44px;
    background: white;
    border-radius: 50%;
  }
  .start {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #ffffff;
    text-decoration: none;
  }
</style>

<template lang="pug">
  .header
    back-button-component(@click.native='clickBackBtn')
    .start-area
      //- .start(@click='redirectStart') 시작하기
</template>

<script>
import BackButtonComponent from '@/components/header_back_btn';

export default {
  methods: {
    clickBackBtn() {
      this.$emit('click-back');
    },
    redirectStart() {
      this.$emit('click-start');
    },
  },
  components: {
    BackButtonComponent,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/header/back_start.vue